import { I18n } from '@app/i18n/strings-keys';
import {
  COMMON_ACTION_TYPES,
  COMMON_ACTION_TYPES_REJECT,
} from '../types/common/common-actions';

export const COMMON_ACTION_VALUE_ENUM_OPTIONS = {
  [COMMON_ACTION_TYPES.Cancel]: I18n.Common.cancel,
  [COMMON_ACTION_TYPES.Accept]: I18n.Common.accept,
  [COMMON_ACTION_TYPES.Approve]: I18n.Common.approve,
  [COMMON_ACTION_TYPES.Duplicate]: I18n.Common.duplicate,
  [COMMON_ACTION_TYPES.Edit]: I18n.Common.edit,
  [COMMON_ACTION_TYPES.Export]: I18n.Common.export,
  [COMMON_ACTION_TYPES.Print]: I18n.Common.print,
  [COMMON_ACTION_TYPES.Reject]: I18n.Common.reject,
  [COMMON_ACTION_TYPES_REJECT]: I18n.Common.reject,
  [COMMON_ACTION_TYPES.Void]: I18n.Common.void,
  [COMMON_ACTION_TYPES.Remove]: I18n.Common.remove,
  [COMMON_ACTION_TYPES.Reopen]: I18n.Common.reopen,
  [COMMON_ACTION_TYPES.Submit]: I18n.Common.submit,
  [COMMON_ACTION_TYPES.View]: I18n.Common.view,
};

export const COMMON_ACTION_DONE_VALUE_ENUM_OPTIONS = {
  [COMMON_ACTION_TYPES.Cancel]: I18n.Status.canceled,
  [COMMON_ACTION_TYPES.Accept]: I18n.Common.accept,
  [COMMON_ACTION_TYPES.Reject]: I18n.Status.rejected,
  [COMMON_ACTION_TYPES_REJECT]: I18n.Status.rejected,
  [COMMON_ACTION_TYPES.Submit]: I18n.Status.submitted,
};
